import { AiAgentSkill, UserSkill } from "./skill";
import { AiAgentKnowledgeDocumentDto } from "./knowledgeDocument";
import { AiAgentMcpServerDto } from "./mcpServer";
import { LicenseType } from "./user";

export interface AiAgent {
    id: string;
    name: string;
    microsoftFoundryId: string;
    currentUsage: number;
    maxUsage: number;
    maxWorkload: number;
    skills?: AiAgentSkill[];
    licenseType: LicenseType;
    [key: string]: any;
}

export interface PagedAiAgentResponse {
    totalCount: number;
    items: AiAgent[];
}

export interface AiAgentRights {
    id: string;
    name: string;
    microsoftFoundryAgentId: string;
    currentUsage: number;
    maxUsage: number;
    maxWorkload: number;
    userSkills?: UserSkill[];
    licenseType: LicenseType;
    [key: string]: any;
}

export interface AiAgentRightsChanged {
    id: string;
    name: string;
    agentId: string;
    licenseType: LicenseType;
    [key: string]: any;
}

export interface AiAgentUsage {
    id: string;
    initialUsage: number;
    newUsage?: number;
}

export enum KnowledgeSyncStatus {
    NotSynced = 0,
    InProgress = 1,
    Synced = 2,
    SyncFailed = 3,
}

export enum McpServerSyncStatus {
    NotSynced = 0,
    InProgress = 1,
    Synced = 2,
    SyncFailed = 3,
}

export enum KnowledgeSyncOverview {
    Synced = 0,
    Unsynced = 1,
    InProgress = 2,
}

export interface AiAgentDto {
    id: string;
    name: string;
    microsoftFoundryAgentId: string;
    currentUsage: number;
    maxUsage: number;
    maxWorkload: number;
    userSkills: AiAgentSkill[];
    licenseType: LicenseType;
    azureVoiceName?: string;
    microsoftFoundryModelName?: string;
    instructionsTemplateId?: string;
    knowledgeDocuments?: AiAgentKnowledgeDocumentDto[];
    mcpServers?: AiAgentMcpServerDto[];
    maxTokenBudget?: number;
    knowledgeSyncStatus?: KnowledgeSyncStatus;
    mcpServerSyncStatus?: McpServerSyncStatus;
    knowledgeSummary?: string;
}

export interface AiAgentValidationResult {
    isValid: boolean;
    message?: string;
}